import { Utils } from "../../../../../../services/utils.service";
import { DataCollection } from "../../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../infrastructure/enums";
import { TransportData } from "../../../../../infrastructure/transportdata";

export class SCFetchRequest {
  public static readonly FetchRequestType: string = "sc_master_fetch_request";
sc_ids: number[] = [];
zone_ids: number[] = [];
district_ids: number[] = [];
block_ids: number[] = [];
bcm_post_ids: number[] = [];
phc_ids: number[] = [];
af_ids: number[] = [];

  public MergeIntoTransportData = (td: TransportData) => {
    let coll = DataContainerService.GetInstance().GetOrCreateCollection(
      td.MainData,
      SCFetchRequest.FetchRequestType
    ) as DataCollection;
    coll.Entries.push(this);
  };

  public FormulateTransportData = () => {
    let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
    this.MergeIntoTransportData(td);

    return td;
  };
}
